import { createSlice, useDispatch } from '@oceanjs/core';
import { useCallback } from 'react';
import { useLibrarySelector } from '../internal/hooks/useLibrarySelector';
const initialState = { language: 'en' };
const languageSlice = createSlice({
    name: 'language',
    initialState: initialState,
    reducers: {
        setLanguage: (state, action) => {
            state.language = action.payload;
        },
    },
});
export const { setLanguage } = languageSlice.actions;
export const languageReducer = languageSlice.reducer;
/**
 * Returns the current language the app is displayed in
 * @returns Current language
 */
export function useCurrentLanguage() {
    return useLibrarySelector((state) => state.language.language);
}
/**
 * Creates a callback to change the current app language
 * @returns Callback to change the app language
 * @example
 * ```js
 * const switchLanguage = useSwitchCurrentLanguage();
 * switchLanguage('de');
 * ```
 */
export function useSwitchCurrentLanguage() {
    const dispatch = useDispatch();
    return useCallback((language) => dispatch(setLanguage(language)), [dispatch]);
}
//# sourceMappingURL=language.js.map